
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Das serielle Intervall definiert das durchschnittliche Intervall vom Beginn der Erkrankung eines ansteckenden Falles bis zum Erkrankungsbeginn eines von diesem angesteckten Falles. Das serielle Intervall ist meistens länger als die Inkubationszeit, weil die Ansteckung im Allgemeinen erst dann erfolgt, wenn ein Fall symptomatisch geworden ist. Das serielle Intervall lag in einer `}<Link disco href='https://www.nejm.org/doi/full/10.1056/NEJMoa2001316' mdxType="Link">{`Studie`}</Link>{` mit 425 Patienten im Mittel bei 7,5 und in einer `}<Link disco href='https://www.ncbi.nlm.nih.gov/pubmed/32145466' mdxType="Link">{`anderen Studie`}</Link>{` bei geschätzten 4 Tagen, basierend auf der Analyse von 28 infizierten Paaren. `}<strong parentName="p">{`Letztere Ergebnisse würde bedeuten, dass bei der durchschnittlichen Inkubationszeit von 5,5 Tagen die Ansteckung noch vor dem Beginn der Symptomen erfolgte.`}</strong></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;